import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("mea_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

const NO_RETRY = ["/auth/login", "/auth/register", "/auth/refresh", "/auth/me"];

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const config = error.config || {};
    const url = config.url || "";
    const skip = NO_RETRY.some((p) => url.includes(p));
    if (error.response?.status !== 401 || skip || config.retried) {
      return Promise.reject(error);
    }
    config.retried = true;
    const hadToken = !!localStorage.getItem("mea_token");
    try {
      const { data } = await api.post("/auth/refresh");
      if (data?.token) localStorage.setItem("mea_token", data.token);
      return api(config);
    } catch (refreshError) {
      localStorage.removeItem("mea_token");
      if (hadToken && window.location.pathname !== "/connexion") {
        // Redirection différée hors du cycle de rendu React : évite la course d'affichage
        // qui peut faire basculer l'application sur l'écran d'erreur à l'expiration de session.
        setTimeout(() => window.location.assign("/connexion"), 0);
      }
      return Promise.reject(error);
    }
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Une erreur est survenue. Veuillez réessayer.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const eur = (n) =>
  new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(n || 0);

export const km = (n) => `${new Intl.NumberFormat("fr-FR").format(n || 0)} km`;

export const dateFr = (d) =>
  d ? new Date(d).toLocaleDateString("fr-FR", { day: "2-digit", month: "short", year: "numeric" }) : "—";
